import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';

export default class AuszeichnungenPlugin extends Plugin {

    init() {
        this._registerEvents();
    }

    _registerEvents() {
        $(this.el).find('.auszeichnungen-widget__more').on('click', () => {
            this._loadMore();
        });

        this.observer = new IntersectionObserver( this._observerHandler );
        this.observer.observe(this.el);
    }

    _loadMore() {
        var nextItems = $('.auszeichnungen-widget__item:not(.is--visible)').slice(0, 5);
        nextItems.addClass('is--visible');

        $('.auszeichnungen-widget__item.is--last').removeClass('is--last');

        if ($('.auszeichnungen-widget__item:not(.is--visible)').length == 0) {
            $('.auszeichnungen-widget__more').addClass('is--hidden');
        }

        var timeline = anime.timeline({
            easing: "easeInOutQuad",
            duration: 1000
        });

        var items = document.querySelectorAll('.auszeichnungen-widget__item.is--visible:not(.is--loaded)');

        items.forEach((item, index) => {

            timeline.add({
                targets: item,
                opacity: 1,
                easing: "easeInOutQuad",
                duration: 1000,
                //delay: index*1000,
                begin: () => {

                    item.classList.add('is--loading');
                    //this._setLineWidth(item.querySelector('.auszeichnungen-widget__item-letters'), item.querySelector('.auszeichnungen-widget__item-line'))

                    var lettersElement = item.querySelector('.auszeichnungen-widget__item-letters');
                    var lineElement = item.querySelector('.auszeichnungen-widget__item-line');

                    const umlautMap = [
                        'ä',
                        'ü',
                        'ö'
                    ];
            
                    var letters = lettersElement.textContent.toLowerCase();
                    var hasUmlaut = umlautMap.some(v => letters.includes(v));
                    var width = lettersElement.offsetWidth - 3;
            
                    if (hasUmlaut) {
                        lineElement.classList.add('has--umlaut');
                    }
                    
                    lineElement.style.width = width + 'px';
                },
                complete: () => {
                    item.classList.remove('is--loading');
                    item.classList.add('is--loaded');

                    $('.auszeichnungen-widget__item.is--visible').each((index, element) => {
                        var $this = $(element);

                        if ($(item).index() == $this.siblings('.is--visible').length) {
                            $(item).addClass('is--last');
                        }
                    });                         
                }
            });
        });
    }

    _observerHandler(entries, observer) {
            
        entries.forEach(entry => {

            if ( entry.intersectionRatio > 0 ) {

                var timeline = anime.timeline({
                    easing: "easeInOutQuad",
                    duration: 1000
                });

                var items = document.querySelectorAll('.auszeichnungen-widget__item.is--visible');

                items.forEach((item, index) => {

                    timeline.add({
                        targets: item,
                        opacity: 1,
                        easing: "easeInOutQuad",
                        duration: 1000,
                        //delay: index*1000,
                        begin: () => {

                            item.classList.add('is--loading');
                            //this._setLineWidth(item.querySelector('.auszeichnungen-widget__item-letters'), item.querySelector('.auszeichnungen-widget__item-line'))

                            var lettersElement = item.querySelector('.auszeichnungen-widget__item-letters');
                            var lineElement = item.querySelector('.auszeichnungen-widget__item-line');

                            const umlautMap = [
                                'ä',
                                'ü',
                                'ö'
                            ];
                    
                            var letters = lettersElement.textContent.toLowerCase();
                            var hasUmlaut = umlautMap.some(v => letters.includes(v));
                            var width = lettersElement.offsetWidth - 3;
                    
                            if (hasUmlaut) {
                                lineElement.classList.add('has--umlaut');
                            }
                            
                            lineElement.style.width = width + 'px';
                        },
                        complete: () => {
                            item.classList.remove('is--loading');
                            item.classList.add('is--loaded');

                            $('.auszeichnungen-widget__item.is--visible').each((index, element) => {
                                var $this = $(element);

                                if ($(item).index() == $this.siblings('.is--visible').length) {
                                    $(item).addClass('is--last');
                                }
                            });                         
                        }
                    });
                });

                observer.unobserve( entry.target );

            }
            
        })
    }



    _setLineWidth(lettersElement, lineElement) {

        const umlautMap = [
            'ä',
            'ü',
            'ö'
        ];

        var letters = lettersElement.textContent.toLowerCase();
        var hasUmlaut = umlautMap.some(v => letters.includes(v));
        var width = lettersElement.offsetWidth - 3;

        if (hasUmlaut) {
            lineElement.classList.add('has--umlaut');
        }
        
        lineElement.style.width = width + 'px';

    }

}